module.exports = __webpack_public_path__ + "img/Radana Finance.aa49a55b.png";